export default {
  bot: 'Bot',
  agent: 'Atendente',
  sequential_id: 'Ticket',
  customer_name: 'Cliente',
  queue_time: 'Tempo na Fila',
  first_response_time: 'Primeira resposta',
  attendance_time: 'Tempo de atendimento',
};
